$.rails.allowAction = (link) ->
  return true unless link.attr('data-confirm')
  $.rails.showConfirmDialog(link) # look bellow for implementations
  false # always stops the action since code runs asynchronously

$.rails.confirmed = (link) ->
  link.removeAttr('data-confirm')
  link.trigger('click.rails')
  if link.attr('href') == '#'
    link.trigger('click')

$.rails.showConfirmDialog = (link) ->
  message = link.attr 'data-confirm'
  cp_confirm_dialog message, ->
    $.rails.confirmed link
    if link.attr('href') != '#'
      $('body').addClass('loading')

window.cp_confirm_dialog = (message, success)->
  m = window.get_modal_markup()
  buttons = """
            <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary">OK</button>
            """
  m.html(window.get_modal_content('Confirmation', message, buttons))
  m.attr('id', 'dialog-confirm')
  m.find('.modal-dialog').addClass('modal-sm')
  m.modal('show')
  m.find('.modal-footer button.btn-primary').click ->
    success()
    m.modal('hide')
